var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view',{staticStyle:{"min-height":"calc(100vh - 2.5rem)"}}),_c('FooterEFTG')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }